/**
 * Portal helper that moves an element to a target container (defaults to document.body) Note that PWDS has a Portal
 * component that can be used instead of this helper, but it is not used in this package yet.
 *
 * @example
 *   ```svelte
 *   <script>
 *     import { portal } from './portal';
 *     let element = $state();
 *
 *     $effect(() => {
 *       return portal(element);
 *     });
 *   </script>
 *
 *   <div bind:this={element}>Content</div>
 *   ```;
 *
 * @param element - The element to portal (can be null/undefined)
 * @param target - The target container (defaults to document.body)
 * @returns Cleanup function to remove the element
 */
export function portal(element, target = document.body) {
    if (!element) {
        return undefined;
    }
    if (!target) {
        return undefined;
    }
    target.appendChild(element);
    return () => {
        element.remove();
    };
}
